import type { Stage2GridProps } from "../PreComplianceStep";
import {
	useComplianceGrid,
	useSaveComplianceGrid,
} from "newui/features/Rfx/Evaluation/hooks/useCompliance";
import type { SupplierMeta } from "./SupplierComplianceAccordionItem";
import type { ComplianceGridFormValues } from "./compliance-grid.schema";
import {
	ComplianceGridLoading,
	ComplianceGridError,
	ComplianceGridEmpty,
	ComplianceGridForm,
} from "./components";

export const Stage2ComplianceGrid = ({
	rfxId,
	onBack,
	onComplete,
}: Stage2GridProps) => {
	const { data: grid, isLoading, isError } = useComplianceGrid(rfxId);
	const saveGrid = useSaveComplianceGrid(rfxId);

	if (isLoading) {
		return <ComplianceGridLoading />;
	}

	if (isError || !grid) {
		return <ComplianceGridError />;
	}

	const { questions, suppliers, locked, skipped } = grid;

	if (!suppliers || suppliers.length === 0) {
		return <ComplianceGridEmpty />;
	}

	const initialValues: ComplianceGridFormValues = {
		suppliers: suppliers.map((s) => ({
			invite_id: s.invite_id,
			answers: questions.map((q) => {
				const existing = s.answers.find(
					(a) => a.rfx_evaluation_compliance_question_id === q.id
				);
				return {
					rfx_evaluation_compliance_question_id: q.id,
					is_compliant: existing?.is_compliant ?? null,
				};
			}),
			comments: s.comments,
			is_evaluated: s.is_evaluated,
		})),
	};

	const supplierMeta: SupplierMeta[] = suppliers.map((s) => ({
		invite_id: s.invite_id,
		company_name: s.company_name,
		supplier_logo: s.supplier_logo,
	}));

	return (
		<ComplianceGridForm
			initialValues={initialValues}
			questions={questions}
			supplierMeta={supplierMeta}
			locked={locked}
			skipped={skipped}
			onBack={onBack}
			onComplete={onComplete}
			saveGrid={saveGrid}
		/>
	);
};
